@for (option of options; track option.value) {
  <app-context-menu-item
    [title]="option?.title"
    [close]="true"
    (execute)="handleSelect(option)"
    />
}

<app-context-menu-divider />

<app-date-time-popover
  [fromDate]="dateControl"
  [fromTime]="timeControl"
  [minDate]="minDate()"
  [highlightRange]="false"
  (onSave)="handleCustomSelect()"
  >
  <app-context-menu-item title="Custom date" />
</app-date-time-popover>